export class Rectangle {
  public startX: number;
  public startY: number;
  public width: number;
  public height: number;
  public color: string;
  public windowScrollY: number = window.scrollY;
  public windowScrollX: number = window.scrollX;
}
